import { Loader } from '@googlemaps/js-api-loader';
import { sendErrReport } from "../../infra/utils";
export let PlacesServiceStatus = /*#__PURE__*/function (PlacesServiceStatus) {
  PlacesServiceStatus["INVALID_REQUEST"] = "INVALID_REQUEST";
  PlacesServiceStatus["NOT_FOUND"] = "NOT_FOUND";
  PlacesServiceStatus["OK"] = "OK";
  PlacesServiceStatus["OVER_QUERY_LIMIT"] = "OVER_QUERY_LIMIT";
  PlacesServiceStatus["REQUEST_DENIED"] = "REQUEST_DENIED";
  PlacesServiceStatus["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
  PlacesServiceStatus["ZERO_RESULTS"] = "ZERO_RESULTS";
  return PlacesServiceStatus;
}({});
const ignoreSentryStatuses = [PlacesServiceStatus.NOT_FOUND, PlacesServiceStatus.ZERO_RESULTS, PlacesServiceStatus.OK, PlacesServiceStatus.UNKNOWN_ERROR];
export async function loadGoogleMaps() {
  if (!window.googleMapsApiKey) {
    return undefined;
  }
  return new Loader({
    apiKey: window.googleMapsApiKey,
    version: 'weekly',
    libraries: ['places']
  }).load().then(google => {
    const autocompleteService = new google.maps.places.AutocompleteService();
    const placesService = new google.maps.places.PlacesService(document.createElement('div'));
    const googleMaps = {
      getPlacePredictions: (request, callback) => autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (!ignoreSentryStatuses.includes(status)) {
          sendErrReport("GoogleMaps getPlacePredictions error: ".concat(status));
        }
        callback && callback(predictions, status);
      }),
      getPlaceDetails: (request, callback) => placesService.getDetails(request, (result, status) => {
        if (!ignoreSentryStatuses.includes(status) || !result) {
          return sendErrReport("GoogleMaps getDetails error: ".concat(status));
        }
        callback && callback(result, status);
      })
    };
    return googleMaps;
  }).catch(() => {
    sendErrReport('loadGoogleMapsError');
    return undefined;
  });
}